import React from 'react'

const Footer = () => {
  return (
    <div className='  min-w-full pt-5 px-4 hidden sm:block pb-5'> <footer
    class="text-muted-foreground bg-background min-w-full   "
    id="socials"
  >
    <div class="  border-t min-w-screen pt-4 border-gray-500 flex flex-row justify-between  ">
      <div className=" pl-2 flex ">
        <a
          class="flex items-center flex-col justify-center font-medium text-black  title-font md:justify-start hover:text-blue-550"
          href="/"
        >
          <span class="text-2xl tracking-[1px] font-semibold league-spartan-extrabold">
            hemil .
          </span>
        </a>
        <div className="w-[1px] h-[90%] b-1 bg-[#9ca3af] ml-1 " />
        <p className=" text-left justify-self-start text-sm  text-black sm:ml-4 sm:pl-4   s sm:mt-0">
          © 2024 Hemil Dudhat.
        </p>
      </div>
      <div className="inline-flex justify-center mt-4 mr-4  sm:mt-0 sm:justify-start -ml-6 sm:ml-auto">
        <a
          class="ml-3  text-black transition-colors hover:text-blue-550"
          href="https://github.com/Hemil36"
          rel="noopener noreferrer"
          target="_blank"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>
          </svg>
          <span class="sr-only">Go to GitHub profile</span>
        </a>
        <a
          class="ml-3 text-black transition-colors hover:text-blue-550"
          href="https://x.com/hemil36"
          rel="noopener noreferrer"
          target="_blank"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>
          </svg>
          <span class="sr-only">Go to Twitter profile</span>
        </a>
        <a
          class="ml-3  text-black transition-colors hover:text-blue-550"
          href="https://www.linkedin.com/in/hemil-dudhat-52ab51265/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
            <rect x="2" y="9" width="4" height="12"></rect>
            <circle cx="4" cy="4" r="2"></circle>
          </svg>
          <span class="sr-only">Go to LinkedIn profile</span>
        </a>
      </div>
    </div>
  </footer></div>
  )
}

export default Footer